// Check out screen page for ticket entry
import styles from '../css/checkOutScreen.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useRef } from 'react';
import axios from 'axios';
import { serverURL } from '../helpers/dataServerURL';
import HeroTicketEntry from './hero';
import { useReactToPrint } from 'react-to-print';
import CheckOutTicketInfo from '../components/CheckOutTicketInfo';
import { calculateTimeDifference } from '../helpers/timeDifference';
import { convertToDatabaseDateTime } from '../helpers/timeDifference';
import { Slide, toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaTicket } from 'react-icons/fa6';

export default function CheckOutScreen() {
  convertToDatabaseDateTime(new Date());
  const [ticketNumber, setTicketNumber] = useState('');
  const [locator, setLocator] = useState('');
  const [carInfo, setCarInfo] = useState('');
  const [colorInfo, setColorInfo] = useState('');
  const [licenseInfo, setLicenseInfo] = useState('');
  const [sectionInfo, setSectionInfo] = useState('');
  const [laneInfo, setLaneInfo] = useState('');
  const [spotInfo, setSpotInfo] = useState('');
  const [checkIn, setCheckIn] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const contentRef = useRef(null);
  const stayHrsRef = useRef();
  const stayMinRef = useRef();

  const logInURL = serverURL.server.url;

  // Get current date and time for check out in SQL format. Convert to YYYY-MM-DD HH:MM:SS from ISO format
  const currentDateTime = new Date();
  const checkOutDatabaseDate = convertToDatabaseDateTime(currentDateTime);
  // const databaseTime = `${currentDateTime.getHours().toString().padStart(2, '0')}:${currentDateTime.getMinutes().toString().padStart(2, '0')}:${currentDateTime.getSeconds().toString().padStart(2, '0')}`;
  // const fullDateTime = `${databaseDate} ${databaseTime}`;
  // const checkInDatabaseDate = `${checkIn.getFullYear()}-${checkIn.getMonth() + 1}-${checkIn.getDate()} ${checkIn.getHours().toString().padStart(2, '0')}:${checkIn.getMinutes().toString().padStart(2, '0')}:${checkIn.getSeconds().toString().padStart(2, '0')}`;
  // console.log(
  //   'Check In for DB:',
  //   checkInDatabaseDate,
  // );

  // useEffect(() => {
  //   if (
  //     location.state?.enteredTicket
  //   ) {
  //     setTicketNumber(
  //       location.state.enteredTicket
  //     );
  //     window.alert(
  //       `Ticket Number ${location.state.enteredTicket} entered`
  //     );
  //   }
  // }, [location.state?.enteredTicket]);

  async function findTicket() {
    // Pull ticket info from api and populate ticket details page

    try {
      const response = await axios.get(`${logInURL}/daily/enteredTicket/${ticketNumber}`);
      if (response.data.length > 0) {
        setTicketNumber(response.data[0].Ticket);
        setLocator(response.data[0].Locator);
        setCarInfo(response.data[0].CarMake);
        setColorInfo(response.data[0].CarColor);
        setLicenseInfo(response.data[0].LicensePlate);
        setSectionInfo(response.data[0].SectionName);
        setLaneInfo(response.data[0].LaneNum);
        setSpotInfo(response.data[0].SpaceNum);
        setCheckIn(new Date(response.data[0].TicketAdded).toLocaleString());
      } else {
        toast.error(
          <div>
            <h3>Ticket Not Found</h3>
            <p>No active ticket found for ticket number {ticketNumber}.</p>
            <p>To try again, click 'Close' to exit.</p>
            <button
              style={{
                marginTop: '5px',
                padding: '10px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                cursor: 'pointer',
              }}
              onClick={() => {
                toast.dismiss();
                setTimeout(() => {
                  setTicketNumber('');
                }, 500);
              }}
            >
              Close
            </button>
          </div>,
          { hideProgressBar: true, closeOnClick: false, pauseOnHover: false, autoClose: false },
        );
      }
    } catch (error) {
      console.error('Error fetching ticket info:', error);
    }
  }

  // Post checkouts to daily checkouts table
  async function postCheckOut() {
    stayHrsRef.current = calculateTimeDifference(checkIn, new Date()).hours;
    stayMinRef.current = calculateTimeDifference(checkIn, new Date()).minutes;
    try {
      const response = await axios.post(`${logInURL}/checkOuts/checkOutVehicle`, {
        Ticket: ticketNumber,
        // convert to SQL datetime format
        CheckOutDateTime: checkOutDatabaseDate,
        // Convert from local date and time to ISO format for SQL
        CheckIn: convertToDatabaseDateTime(checkIn),
        SectionName: sectionInfo,
        LaneNum: laneInfo,
        SpaceNum: spotInfo,
        StayHr: stayHrsRef.current || 0,
        StayMin: stayMinRef.current || 0,
      });
      if (response.status === 200) {
        console.log(
          'Check out posted successfully:',
          new Date(checkIn).toISOString().slice(0, 19).replace('T', ' '),
          checkIn,
        );
      }
    } catch (error) {
      console.error('Error posting check out:', error);
    }
  }

  // Delete ticket from spaces table on check out
  async function deleteTicketLocation() {
    try {
      const response = await axios.delete(
        `${logInURL}/spaces/deleteCarLocation/${location?.state?.enteredTicket || ticketNumber}`,
      );
      if (response.data) {
        console.log('Ticket location deleted successfully');
      } else {
        console.error('Error deleting ticket location');
      }
    } catch (error) {
      console.error('Error deleting ticket location:', error);
    }
  }

  const handlePrint = useReactToPrint({
    contentRef, //content to print, ContentRef is assigned. ContentRef is a required property
    // to the div containing ticket details. contentRef is defined using useRef hook
    // so that we can access the DOM element directly.
    // When handlePrint is called, it retrieves the current value of contentRef
    // (which is the div) and uses it as the content to print.
    // This allows us to print only the specific section of the page
    // that contains the ticket details.
    //I can change the paper size by adding this code line size: 800mm 200mm margin:0;
    documentTitle: `Ticket_${ticketNumber}_Receipt`, // Title of the printed document
    pageStyle: `
    @page {
      size: auto; 
      margin: 10mm;
    }

    body {
      background: white;
       -webkit-print-color-adjust: exact;
     }
    `, // Custom CSS for the printed page to ensure it fits on a receipt
    // and has a white background
  });

  function clearFields() {
    setTicketNumber('');
    setLocator('');
    setCarInfo('');
    setColorInfo('');
    setLicenseInfo('');
    setSectionInfo('');
    setLaneInfo('');
    setSpotInfo('');
    setCheckIn(null);
  }

  return (
    <div className={styles.topContainer}>
      <ToastContainer position="top-center" theme="light" transition={Slide} />
      <HeroTicketEntry
        openCheckOut={() => {
          navigate('/');
          // back to previous page. navigate(-1) takes user back to last page
          // navigate(-1);
        }}
        title="Check Out Screen"
        isBtnVisible={true}
        btnIcon={
          <FaTicket
            style={{
              marginRight: '5px',
              top: '5px',
              position: 'relative',
            }}
            size={'24px'}
          />
        }
        btnCaption="Check In"
      />

      <div className={styles.checkOutContainer}>
        <CheckOutTicketInfo ticket={ticketNumber} setTicket={setTicketNumber} findTkt={() => findTicket()} />
        <div ref={contentRef}>
          <div className={styles.sectionHeader}>
            <h4>Check Out Details</h4>
          </div>
          <div className={styles.inputGroup}>
            <label className={styles.checkOutLabel}>Ticket Number:</label>
            <label className={styles.resultLabel}>{ticketNumber}</label>
          </div>
          <div className={styles.inputGroup}>
            <label className={styles.checkOutLabel}>Locator:</label>
            <label className={styles.resultLabel}>{locator}</label>
          </div>
          {/* <div className={styles.inputGroup}>
            <label className={styles.checkOutLabel}>Checked In:</label>
            <label className={styles.resultLabel}>{checkIn}</label>
          </div> */}
          {/* <div className={styles.inputGroup}>
            <label className={styles.checkOutLabel}>Stay Duration:</label>
            <label className={styles.resultLabel}>
              {checkIn &&
                calculateTimeDifference(checkIn, new Date(), stayHrsRef.current, stayMinRef.current).timeDiff}
            </label>
          </div> */}
          <div className={styles.inputGroup}>
            <label htmlFor="carMake" className={styles.checkOutLabel}>
              Car Make:
            </label>
            <label className={styles.resultLabel}>{carInfo}</label>
          </div>
          <div className={styles.inputGroup}>
            <label htmlFor="carColor" className={styles.checkOutLabel}>
              Car Color:
            </label>
            <label className={styles.resultLabel}>{colorInfo}</label>
          </div>
          <div className={styles.inputGroup}>
            <label htmlFor="sectionName" className={styles.checkOutLabel}>
              Section Name:
            </label>
            <label className={styles.resultLabel}>{sectionInfo}</label>
          </div>
          <div className={styles.inputGroup}>
            <label htmlFor="laneNumber" className={styles.checkOutLabel}>
              Lane Number:
            </label>
            <label className={styles.resultLabel}>{laneInfo}</label>
          </div>
          <div className={styles.inputGroup}>
            <label htmlFor="spotNumber" className={styles.checkOutLabel}>
              Spot Number:
            </label>
            <label className={styles.resultLabel}>{spotInfo}</label>
          </div>
          <div className={styles.inputGroup}>
            <label htmlFor="licensePlate" className={styles.checkOutLabel}>
              License Plate:
            </label>
            <label className={styles.resultLabel}>{licenseInfo}</label>
          </div>
        </div>
        <button
          className={styles.closeBtn}
          type="button"
          onClick={() => {
            handlePrint();
            postCheckOut();
            deleteTicketLocation();
            clearFields();
          }}
        >
          Print Receipt
        </button>
      </div>
    </div>
  );
}
